export const PATTERN_PALETTE = [
  {
    key: 'teal',
    color: '#1ba5a7',
    foreground: '#10233f',
    token: 'var(--pacilo-pattern-teal)',
  },
  {
    key: 'gold',
    color: '#d8a43f',
    foreground: '#10233f',
    token: 'var(--pacilo-pattern-gold)',
  },
  {
    key: 'purple',
    color: '#9d28ac',
    foreground: '#ffffff',
    token: 'var(--pacilo-pattern-purple)',
  },
  {
    key: 'orange',
    color: '#ff981f',
    foreground: '#10233f',
    token: 'var(--pacilo-pattern-orange)',
  },
  {
    key: 'coral',
    color: '#ff5726',
    foreground: '#10233f',
    token: 'var(--pacilo-pattern-coral)',
  },
  {
    key: 'blue',
    color: '#1a96f0',
    foreground: '#10233f',
    token: 'var(--pacilo-pattern-blue)',
  },
];

const ALIASES = {
  r: 'teal',
  realistic: 'teal',
  realistic_pattern: 'teal',
  real: 'teal',
  teal: 'teal',
  turquoise: 'teal',
  'الواقعي': 'teal',
  واقعي: 'teal',
  i: 'gold',
  investigative: 'gold',
  investigative_pattern: 'gold',
  gold: 'gold',
  'الاستقصائي': 'gold',
  استقصائي: 'gold',
  البحثي: 'gold',
  a: 'purple',
  artistic: 'purple',
  artistic_pattern: 'purple',
  purple: 'purple',
  'الفني': 'purple',
  فني: 'purple',
  s: 'orange',
  social: 'orange',
  social_pattern: 'orange',
  orange: 'orange',
  'الاجتماعي': 'orange',
  اجتماعي: 'orange',
  e: 'coral',
  enterprising: 'coral',
  enterprising_pattern: 'coral',
  coral: 'coral',
  'المغامر': 'coral',
  مغامر: 'coral',
  الريادي: 'coral',
  c: 'blue',
  conventional: 'blue',
  conventional_pattern: 'blue',
  blue: 'blue',
  'التقليدي': 'blue',
  تقليدي: 'blue',
  المنظم: 'blue',
};

const PALETTE_BY_KEY = Object.fromEntries(PATTERN_PALETTE.map((entry) => [entry.key, entry]));
const PALETTE_BY_HEX = Object.fromEntries(
  PATTERN_PALETTE.map((entry) => [entry.color.toLowerCase(), entry]),
);

export function normalizePatternKey(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, '_');
}

function hashToIndex(value) {
  const text = String(value || 'pattern');
  let hash = 0;
  for (let index = 0; index < text.length; index += 1) {
    hash = ((hash << 5) - hash) + text.charCodeAt(index);
    hash |= 0;
  }
  return Math.abs(hash) % PATTERN_PALETTE.length;
}

function appearanceForKey(key) {
  return PALETTE_BY_KEY[key] || PATTERN_PALETTE[0];
}

export function resolvePatternAppearance(source = {}) {
  const candidates = [
    source.short_code,
    source.style_key,
    source.slug,
    source.code,
    source.key,
    source.name_en,
    source.title_en,
    source.name,
    source.title,
  ];

  for (const candidate of candidates) {
    if (!candidate) {
      continue;
    }
    const alias = ALIASES[normalizePatternKey(candidate)] || ALIASES[String(candidate).trim()];
    if (alias) {
      return appearanceForKey(alias);
    }
  }

  const incomingColor = String(source.color || '').trim().toLowerCase();
  if (PALETTE_BY_HEX[incomingColor]) {
    return PALETTE_BY_HEX[incomingColor];
  }

  const stableId = source.short_code
    || source.style_key
    || source.slug
    || source.version_pattern_id
    || source.id
    || source.name
    || source.title
    || 'pattern';

  return PATTERN_PALETTE[hashToIndex(stableId)];
}

export function patternCssVars(source = {}) {
  const appearance = resolvePatternAppearance(source);
  return {
    '--section-pattern': appearance.color,
    '--section-pattern-fg': appearance.foreground,
  };
}
